import { CellAlignTypes } from 'modules/experiments/types';
import { CampaignsSendMessagesLogsTableColumnData } from './types';
import { MessageMedium } from 'constants/messageMediums';
import {
  ActionColumn,
  CampaignColumn,
  DateColumn,
  TableLink,
  StyledTableCell,
} from './components/columns';

const PROFILE_DETAILS_URL = '/users/profiles/';

export const tableColumnsConfig: CampaignsSendMessagesLogsTableColumnData[] = [
  {
    align: CellAlignTypes.flexStart,
    name: 'Campaign Name',
    value: 'campaignName',
    sortable: false,
    RowCell: ({ row }) => (
      <StyledTableCell>
        <CampaignColumn row={row} />
      </StyledTableCell>
    ),
  },
  {
    name: 'Send Date',
    value: 'sendTimeMillis',
    align: CellAlignTypes.flexStart,
    RowCell: ({ row }) => (
      <StyledTableCell>
        <DateColumn row={row} />
      </StyledTableCell>
    ),
  },
  {
    name: 'User',
    value: 'userIdentifier',
    sortable: false,
    align: CellAlignTypes.flexStart,
    RowCell: ({ row }) => (
      <StyledTableCell>
        <TableLink href={`${PROFILE_DETAILS_URL}${row.userIdentifier}`}>
          {row.userIdentifier}
        </TableLink>
      </StyledTableCell>
    ),
  },
  {
    name: '',
    value: 'actions',
    align: CellAlignTypes.flexStart,
    sortable: false,
    RowCell: ({ row }) => (
      <StyledTableCell>
        <ActionColumn row={row} />
      </StyledTableCell>
    ),
  },
];

export const MESSAGE_MEDIUM_FILTERS = [
  {
    id: MessageMedium.Email,
    label: 'Email',
  },
  {
    id: MessageMedium.Push,
    label: 'Push',
  },
  {
    id: MessageMedium.SMS,
    label: 'SMS',
  },
  {
    id: MessageMedium.InApp,
    label: 'In-App',
  },
  {
    id: MessageMedium.WebPush,
    label: 'Web Push',
  },
];
